<template>
    <div class="row">
        <div class="col-sm-8">
            <div class="card">
                <div class="p-0 pt-0 card-body">
                    <div class="table-responsive p-2">
                        <el-table border class="el-table-css" :data="this.tableData" style="width: 100%;">
                            <el-table-column width="40">
                                <template #default>
                                    <div class="text-center">
                                        <i class="text-lg bi bi-download"></i> 
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="Tarix" prop="createdDateStr" width="120">
                            </el-table-column>
                            <el-table-column label="Faylın adı">
                                <template #default="scope">
                                    <div>
                                        <img style="width: 30px;"
                                            :src="scope.row.ext === '.xlsx' ? require('@/assets/img/icons/microsoft-files/.xlsx.png') :
                                                scope.row.ext === '.docx' ? require('@/assets/img/icons/microsoft-files/.docx.png') :
                                                    scope.row.ext === '.pdf' ? require('@/assets/img/icons/microsoft-files/.pdf.png') : require('@/assets/img/icons/microsoft-files/photo.png')"
                                            alt="file-icon">
                                        &nbsp;&nbsp;
                                        <a @click="download(scope.row.title)" style="cursor: pointer;"
                                            class="text-decoration-underline">
                                            {{ scope.row.title }}
                                        </a>
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column width="43">
                                <template #default>
                                    <el-button type="danger" style="padding: 0 !important;" :icon="Delete"
                                        class="edit-btn" text />
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <el-upload class="upload-demo" drag :action="fileurl" multiple>
                <i class="fa fa-upload"></i>
                <div class="el-upload__text">
                    Drop file here or <em>click to upload</em>
                </div>
            </el-upload>
        </div>
    </div>
</template>

<script> 
import { Download, Delete, UploadFilled} from "@element-plus/icons-vue";

export default {
    data() {
        return {
            UploadFilled,
            Delete,
            tableData: [
                {
                    createdDateStr: "21.08.2025",
                    title: "Hesabat_2025.xlsx",
                    ext: ".xlsx",
                    commandUserId: 1
                },
                {
                    createdDateStr: "19.08.2025",
                    title: "Müqavilə.docx",
                    ext: ".docx",
                    commandUserId: 2
                },
                {
                    createdDateStr: "15.08.2025",
                    title: "Şərtlər.pdf",
                    ext: ".pdf",
                    commandUserId: 1
                },
                {
                    createdDateStr: "10.08.2025",
                    title: "Foto.png",
                    ext: ".png",
                    commandUserId: 3
                }
            ],
            alert: false,
            Download,
            alertColor: null
        }
    }
}
</script>
<style>
.el-upload {
    --el-upload-dragger-padding-horizontal: 60px !important;
    --el-upload-dragger-padding-vertical: 10px;
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    outline: none;
}

.el-upload-dragger {
    background-color: var(--el-fill-color-blank);
    border: 1px dashed var(--el-border-color);
    border-radius: 12px;
    box-sizing: border-box;
    cursor: pointer;
    overflow: hidden;
    padding: var(--el-upload-dragger-padding-horizontal) var(--el-upload-dragger-padding-vertical);
    position: relative;
    text-align: center;
}
</style>